const roundPenceConsistently = (value: number | string): number =>
  parseFloat(`${value}`) < 0
    ? Math.ceil(parseFloat(`${value}`))
    : Math.floor(parseFloat(`${value}`));

export default roundPenceConsistently;
